module.exports = __webpack_public_path__ + "img/app-icon-9.7cd4ea02.svg";